import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import BillPrint from '../salereturn/Bill';
import ReactDOM from 'react-dom';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';

const SaleReturnDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate, roleName } = useAuth();

    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);

    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [showCardFields, setShowCardFields] = useState(false);
    const [showupiFields, setShowupiFields] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
    }, []);


    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleReturnApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleReturnApi', `/CardType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCardTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Card Type dropdown options:', error);
            });
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('SaleReturnApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setInvoicedeatils(response.response_data.SaleDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                    setSelectedSalesMan(response.response_data.Sale.SalesManId);
                    setSelectedCardType(response.response_data.Sale.CardType);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'GVAmount') {
            const gvamt = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                GVAmount: gvamt.toFixed(2),
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let grate = (rate - discamt).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount);
        }
        else if (name === 'GSTNumber') {
            const gstno = value;
            setFormData((prevData) => ({
                ...prevData,
                GSTNumber: gstno,
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let grate = (rate - discamt).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!gstno) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = gstno.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }
        else if (name === 'CardAmount') {

            const cardAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                CardAmount: cardAmount.toFixed(2),
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let grate = (rate - discamt).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, cardAmount, UPIAmount);

        }
        else if (name === 'UPIAmount') {

            const upiAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                UPIAmount: upiAmount.toFixed(2),
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let grate = (rate - discamt).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, upiAmount);

        }
        else {

            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

        }

    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        // if (!formData.ContactNumber) {
        //     setErrorMessage('Contact Number is required !');
        //     setIsLoading(false);
        //     return;
        // }

        if (!formData.SaleBillNumber) {
            setErrorMessage('Sale Bill Number is required !');
            setIsLoading(false);
            return;
        }


        // Cash amount validation
        if (formData.CashAmount < 0) {
            setErrorMessage('Cash Amount less than 0 is not allowed!');
            setIsLoading(false);
            return;
        }

        // Card amount validation
        if (formData.CardAmount > 0) {
            if (!formData.CardNumber) {
                setErrorMessage('Card Number is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
            if (!selectedCardType) {
                setErrorMessage('Card Type is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }

        if (!selectedSalesMan) {
            setErrorMessage('Sales Man is required !');
            setIsLoading(false);
            return;
        }

        // Upi amount validation
        if (formData.UPIAmount > 0) {
            if (!formData.UPINumber) {
                setErrorMessage('UPI Number is required when UPI Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }


        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            SalesManId: selectedSalesMan,
            CardType: selectedCardType
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: invoicedeatils
        };

        // Validate form data here if needed

        updateData('SaleReturnApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);


                if (response.response === 'Sale Return Updated Successfully') {
                    const SaleId = response.kotId;
                    handlePrint(SaleId);
                }
                history.push('/SaleReturnIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const handlePrint = async (SaleId) => {
        try {

            const response = await fetchData('SaleReturnApi', `/SalePrint/${SaleId}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record

            const Quantity = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }

    };

    //Items
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await fetchData('SaleReturnApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Code + '-' + item.Name
                }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }

            setFormData(prevData => ({
                ...prevData,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        Rate: '',
        Amount: '',
        DiscountPercentage: '',
        DiscountAmount: '',
        HSNCode: '',
        GSTRate: '',
        TaxableAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        TotalAmount: '',
        balanceStock: 0,
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '1',
            Rate: '',
            Amount: '',
            DiscountPercentage: '',
            DiscountAmount: '',
            HSNCode: '',
            GSTRate: '',
            TaxableAmount: '',
            CGSTAmount: '',
            SGSTAmount: '',
            IGSTAmount: '',
            TotalAmount: '',
            balanceStock: 0,
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        if (modalData.Quantity > modalData.balanceStock) {
            isValid = false;
            errors = "Quantity exceeds available stock.";
        }


        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
                Rate: '',
                Amount: '',
                DiscountPercentage: '',
                DiscountAmount: '',
                HSNCode: '',
                GSTRate: '',
                TaxableAmount: '',
                CGSTAmount: '',
                SGSTAmount: '',
                IGSTAmount: '',
                TotalAmount: '',
                balanceStock: 0,
            });

            setSelectedItem(0);
            //closeModal();

            // Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);


        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };


    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount) => {

        const gvAmount = parseFloat(gvamt) || 0;

        let netamount = parseFloat(TaxableAmount);
        let netAmt = netamount + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
        totalAmt = parseFloat(totalAmt - gvAmount).toFixed(2);
        let cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: parseFloat(totalAmt).toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            GVAmount: gvAmount.toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            CashDiscount: 0,
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData({
            ...modalData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';


        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            let quantity = parseFloat(modalData.Quantity) || 0;;
            let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

            let amount = (quantity * rate).toFixed(2);
            let discamt = ((rate * discountPercentage) / 100).toFixed(2)
            let grate = (rate - discamt).toFixed(2);
            let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

            let cgst = 0;
            let sgst = 0;
            let igst = 0;

            if (!formData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                HSNCode: selectedItemDetail.HSNCode,
                DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountAmount: parseFloat(discamt).toFixed(2),
                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                balanceStock: selectedItemDetail.balanceStock,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '0.00',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                GSTRate: '0',
                HSNCode: '',
                DiscountPercentage: '',
            });
        }
    };

    const [isValid, setIsValid] = useState(true);
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData({
            ...modalData,
            [name]: value,
        });

        const intValue = parseInt(value, 10);

        if (intValue > modalData.balanceStock) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }

        let quantity = parseFloat(value) || 0;
        let rate = parseFloat(modalData.Rate) || 0;
        let gstrate = parseFloat(modalData.GSTRate) || 0;
        let discountPercentage = parseFloat(modalData.DiscountPercentage) || 0;

        let amount = (quantity * rate).toFixed(2);
        let discamt = ((rate * discountPercentage) / 100).toFixed(2)
        let grate = (rate - discamt).toFixed(2);
        let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);
        const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

        let cgst = 0;
        let sgst = 0;
        let igst = 0;

        if (!formData.GSTNumber) {
            cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
        } else {
            const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

            if (gstNumberPrefix !== branchstate) {
                igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
            } else {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            }
        }

        const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

        setModalData({
            ...modalData,
            Quantity: quantity,
            Amount: amount,
            DiscountAmount: parseFloat(discamt).toFixed(2),
            TaxableAmount: parseFloat(taxableamount).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2),
            SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2),
            TotalAmount: parseFloat(totalAmount).toFixed(2),
        });
    };


    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };




    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h5 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Sale Return - Details</h5>

                    <Button

                        component={Link}
                        to="/SaleReturnIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>

                </div>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex">
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '500px', overflowY: 'auto', width: '100%' }}>

                        <div className="w-full mb-2 flex">

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Customer Name
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.CustomerName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CUSTOMER NAME"
                                    name='CustomerName'
                                    readOnly
                                />
                            </div>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                        disabled
                                    />
                                </div>

                            ) : (

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                        disabled
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            )}

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total Quantity
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TotalQuantity}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="TOTAL QUANTITY"
                                    name='TotalQuantity'
                                    readOnly
                                />
                            </div>

                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Address
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.CustomerAddress}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="ADDRESS"
                                    name='CustomerAddress'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    GST Number
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.GSTNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GST NUMBER"
                                    name='GSTNumber'
                                    readOnly
                                />
                            </div>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Sale Bill No
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.SaleBillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="SALE BILL NUMBER"
                                        name='SaleBillNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Sale Bill No
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.SaleBillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="SALE BILL NUMBER"
                                        name='SaleBillNumber'
                                        readOnly
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Sale Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.SaleBillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='SaleBillDate'
                                        disabled
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Sale Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.SaleBillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='SaleBillDate'
                                        disabled
                                    />
                                </div>
                            )}

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Sales Man
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                    value={selectedSalesMan}
                                    // onChange={(e) => setSelectedSalesMan(e.target.value)}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedSalesMan(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            SalesManId: selectedValue,
                                        }));
                                    }}
                                    disabled
                                >
                                    <option value="">Select Sales Man</option>
                                    {dropdownSalesManOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                        </div>

                        <div className="w-full mb-2 flex">
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#CDE69A' }}>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A' }}>Item Name</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'center' }}>Quantity</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'right' }}>MRP</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'right' }}>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => (
                                                <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '55%' }}>{invdetail.ItemName}</td>
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '10%', textAlign: 'center' }}>{invdetail.Quantity}</td>
                                                    {/* <td style={{ padding: '2px', fontSize: '14px', width: '10%', textAlign: 'right' }}>{invdetail.Rate}</td>
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '15%', textAlign: 'right' }}>{invdetail.TotalAmount}</td> */}
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '10%', textAlign: 'right' }}>{invdetail.Rate ? invdetail.Rate.toFixed(2) : "0.00"}</td>
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '15%', textAlign: 'right' }}>{invdetail.TotalAmount ? invdetail.TotalAmount.toFixed(2) : "0.00"}</td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </TableContainer>

                            </div>
                        </div>

                        <div className="w-full mb-2 flex">

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Remarks}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="REMARKS"
                                    name='Remarks'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.TotalAmount ? formData.TotalAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="AMOUNT"
                                    style={{ textAlign: 'right' }}
                                    name='TotalAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Discount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.DiscountAmount ? formData.DiscountAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="DISCOUNT"
                                    style={{ textAlign: 'right' }}
                                    name='DiscountAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Cash Disc
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.CashDiscount ? formData.CashDiscount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CASH DISCOUNT"
                                    style={{ textAlign: 'right' }}
                                    name='CashDiscount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    GV Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.GVAmount ? formData.GVAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GV AMOUNT"
                                    style={{ textAlign: 'right' }}
                                    name='GVAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Net Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.TaxableAmount ? formData.TaxableAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="NET AMOUNT"
                                    name='TaxableAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    CGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.CGSTAmount ? formData.CGSTAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CGST"
                                    name='CGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    SGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.SGSTAmount ? formData.SGSTAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="SGST"
                                    name='SGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    IGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.IGSTAmount ? formData.IGSTAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="IGST"
                                    name='IGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Round Off
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.RoundOff}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="ROUND OFF"
                                    name='RoundOff'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.GrandTotal ? formData.GrandTotal.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GRAND TOTAL"
                                    name='GrandTotal'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Cash
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline ${formData.CashAmount < 0 ? 'text-red-500' : ''}`}

                                    value={formData.CashAmount ? formData.CashAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CASH"
                                    name='CashAmount'
                                    style={{ textAlign: 'right' }}
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Card
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.CardAmount ? formData.CardAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CARD"
                                    name='CardAmount'
                                    style={{ textAlign: 'right' }}
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    UPI
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formData.UPIAmount ? formData.UPIAmount.toFixed(2) : "0.00"}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="UPI"
                                    name='UPIAmount'
                                    style={{ textAlign: 'right' }}
                                    readOnly
                                />
                            </div>

                        </div>

                    </div>
                    {
                        isModalOpen && (
                            <div className="w-full mb-4 flex" style={{ marginLeft: '10px', width: '50%', marginTop: '10px' }}>
                                <div className="w-full pr-4">
                                    <div className="bg-teal-800 rounded-lg shadow-lg p-6">
                                        {errorMessageModel && <p className="text-red-500">{errorMessageModel}</p>}
                                        <p style={{ color: 'whitesmoke', fontWeight: 'bolder' }}>ADD ITEMS</p>
                                        <div className="w-full mb-4 flex">
                                            <div className="w-4/7 mr-3" style={{ marginLeft: '5px', width: '300px' }}>
                                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="Weightage">
                                                    Item Name
                                                </label>
                                                <Select
                                                    value={selectedItems}
                                                    onChange={handleItemSelect}
                                                    options={itemsOptions}
                                                    placeholder="Items"
                                                    isSearchable
                                                />

                                            </div>
                                            <div className="w-1/4 mr-3">
                                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="MinimumStock">
                                                    Quantity
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                    type="number"
                                                    name="Quantity"
                                                    placeholder="Quantity"
                                                    value={modalData.Quantity}
                                                    onChange={handleModalInputChange}
                                                    min={1}
                                                />
                                                {!isValid && (
                                                    <p className="text-red-500 text-xs italic">
                                                        Quantity exceeds available stock.
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="w-1/2 mr-4" >
                                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={saveModalData}>
                                                Add Record
                                            </button>
                                        </div>
                                        <div className="w-1/2 mr-4" style={{ marginLeft: '140px', marginTop: '-40px' }}>
                                            <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal} >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }


                </div>


            </div >
        </Fragment >

    );
};

export default SaleReturnDetails;